import { createSelector } from '@reduxjs/toolkit';

import { isFiltersSelectedSelector } from '@/features/choice/selectors';

import carsCountSelector from './count';

/**
 * Возвращает флаг, который указывает на отсутствует данных по машинам
 */
const isCarsDataMissing = createSelector(
  [carsCountSelector, isFiltersSelectedSelector],
  (carsCount, isFiltersSelected) => {
    return carsCount === 0 && !isFiltersSelected;
  },
);

export default isCarsDataMissing;
